import { render } from "./displaymodulegfig.vue?vue&type=template&id=95b2682a"
import script from "./displaymodulegfig.vue?vue&type=script&lang=js"
export * from "./displaymodulegfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__